import { makeStyles } from '@material-ui/core/styles'

const detailsUseStyles = makeStyles(theme=>({
    selectNavCard:{
        height:"4em",width:"5em",border:0,borderRadius:"22px",
    },
    tableGrid:{
        marginTop:"2em",marginBottom:"2em",width:"96%",height:"50%",marginLeft:"1.5em"
    },
    table: {
        minWidth: 650,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    tableHeader: {
        fontSize: "12px",
        fontWeight: "bolder",
        // width: 17%;
    },
    cardWrapper: {
        padding: "2rem"
    },
    ComplaintDetailCard: {
        zIndex: 0,
        boxShadow: theme.shadows[10],
        marginTop:"16px",
        width: "96%",
        height: "50%",
        marginLeft:"2em"
    },
    heading: {
        fontWeight:'bold',
        fontSize:'0.95rem'
    },
    value: {
        fontSize:'0.85rem',
        // paddingLeft:'5rem'
    },
    statusChangeButton:{
        ...theme.typography.view,
        borderRadius: 50,
        height: "2.5em",
        width: "10em",
        fontSize:"0.71rem",
        border:"none",
        fontWeight:"600",
    }, 
    backButton:{
        ...theme.typography.view,
        borderRadius: 50,
        height: "2.5em",
        width: "10em",
        fontSize:"0.71rem",
        border:"none",
        fontWeight:"600",
        backgroundColor:"Green",
        color:"black",
    },
    dialogButton:{
        ...theme.typography.view,
        borderRadius: 50,
        color: "#fff",
        height: "2.5em",
        width: "7em",
        fontSize:"0.71rem",
        border:"none",
        fontWeight:"600",
        marginBottom:"2em"
    },
    uploadDialogTitle:{
        fontWeight:"700",borderBottom:"1px solid #808080",textAlign:"left",
    },
    superAdminComment: {
        fontWeight:"600",fontSize:"0.60rem"
    },
    superAdminCommentMargin:{
        marginTop:"3.5em",marginBottom:"2em"
    },
    labelMargin:{
        marginTop:"1.5em"
    },
    createdDateGrid: {
        marginLeft:"2em",marginTop:"1.5em"
    },
    textArea:{
        width:"100%",height:"10em",borderRadius:"5px"
    },
    statusText:{
        fontWeight:"600",fontSize:"0.95rem",marginLeft:"2em",color:"#F49D3E",
    },
    statusLabel:{
        fontWeight:"600",fontSize:"0.60rem",marginLeft:"2em"
    },
    complaintDescription: {
        fontSize:"0.65rem",
        maxWidth:"12em",
        height:"4em",
        overflowX: "auto",
        overflowY: "auto"
    },
    gridComplaintDescription:{
        marginLeft:"2em",width:"50%",marginTop:"2em"
    },
}));

export default detailsUseStyles;